import { useEffect } from "react";

import { AppConfig } from "~/AppConfig";
import { useImpersonation } from "~/hooks/useImpersonation";
import { isWhiteLabel } from "~/utils/white-label";

export function HubspotTracking() {
  const { isImpersonating } = useImpersonation();

  useEffect(() => {
    const portalId = AppConfig.HUBSPOT_PORTAL_ID;
    if (!portalId || isImpersonating || isWhiteLabel()) return;
    if (document.getElementById("hs-script-loader")) return;

    const script = document.createElement("script");
    script.id = "hs-script-loader";
    script.src = `https://js.hs-scripts.com/${portalId}.js`;
    script.async = true;
    script.defer = true;
    document.head.appendChild(script);
  }, [isImpersonating]);

  return null;
}
